export default __webpack_public_path__ + "static/media/empushy_logo_white.e71ba885.png";